module.exports = __webpack_public_path__ + "static/media/sync.abf4de74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vectors/sync.svg
// module id = 524
// module chunks = 0